import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram } from 'lucide-react';


const begambleawareImg = '/images/begambleaware.png';
const gamblingCommissionImg = '/images/gambling_commission_logo.png';
const gamcareImg = '/images/gamcare.png';
const gamstopImg = '/images/gamstop_logo.png';
const ageRestrictionImg = '/images/18+.png';

const Footer = () => {
  return (
    <footer className="bg-gray-dark text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src="/images/favicon.webp" 
                alt="Sceptre Slots" 
                className="w-10 h-10 rounded-lg"
                itemprop="logo"
              />
              <span className="text-xl font-bold" itemprop="name">Sceptre Slots</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed" itemprop="description">
              Your trusted guide to the best UK online casinos. 
              Compare bonuses, read reviews, and play smarter.
            </p>
            <p>Email: <a href="mailto:info@sceptreslots.com" itemprop="email">info@sceptreslots.com</a></p>
            <p>Phone: <a href="tel:+448147675497" itemprop="telephone">+44 8147 675 497</a></p>
            <p>Address: <span itemprop="address">London, UK</span></p>
          </div>
          
          
          <div>
            <h3 className="text-white font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/guides" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Guides
                </Link>
              </li>
              <li>
                <Link to="/news" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  News
                </Link>
              </li>
              <li>
                <Link to="/reviews" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Reviews
                </Link>
              </li>
              <li>
                <Link to="/slots" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Slots
                </Link>
              </li>
            </ul>
          </div>




          <div>
            <h3 className="text-white font-bold mb-4">Legal links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-conditions" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link to="/responsible-gaming" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Responsible Gaming
                </Link>
              </li>
            </ul>
          </div>



          <div>
            <h3 className="text-white font-bold mb-4">Responsible Gaming</h3>
            <div className="flex flex-wrap justify-center items-center gap-6 md:gap-8 mb-8">
              <div className="flex items-center">
                <a
                    href="https://www.begambleaware.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80 transition-opacity"
                >
                  <img
                      className="h-[60px] w-auto object-contain"
                      alt="BeGambleAware - Responsible Gambling"
                      src={begambleawareImg}
                  />
                </a>
              </div>

              <div className="flex items-center">
                <a
                    href="https://www.gamblingcommission.gov.uk/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80 transition-opacity"
                >
                  <img
                      className="h-[60px] w-auto object-contain"
                      alt="UK Gambling Commission"
                      src={gamblingCommissionImg}
                  />
                </a>
              </div>

              <div className="flex items-center">
                <a
                    href="https://www.gamcare.org.uk/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80 transition-opacity"
                >
                  <img
                      className="h-[60px] w-auto object-contain"
                      alt="GamCare - Gambling Support"
                      src={gamcareImg}
                  />
                </a>
              </div>

              <div className="flex items-center">
                <a
                    href="https://www.gamstop.co.uk/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80 transition-opacity"
                >
                  <img
                      className="h-[60px] w-auto object-contain"
                      alt="Gamstop - Self-Exclusion"
                      src={gamstopImg}
                  />
                </a>
              </div>

              <div className="flex items-center">
                <img
                    className="h-[60px] w-auto object-contain"
                    alt="18+ Age Restriction"
                    src={ageRestrictionImg}
                />
              </div>
            </div>
          </div>

        </div>
        
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © 2025 Sceptre Slots. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-yellow-accent transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-accent transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
          
          <div className="mt-6 pt-6 border-t border-gray-700">
            <p className="text-gray-400 text-xs leading-relaxed text-center">
              Sceptre Slots operates as an independent review and comparison platform. 
              Certain links featured on our website are affiliate partnerships, which means 
              we may earn a commission when you click through or register through these links. 
              This compensation arrangement does not influence our editorial opinions, 
              reviews, or ratings in any way. All content is created with integrity and 
              transparency. This website is intended for users aged 18 and over only. 
              Please gamble responsibly. For support with problem gambling, visit{' '}
              <a href="https://www.begambleaware.org" target="_blank" rel="noopener noreferrer" className="text-yellow-accent hover:underline">
                BeGambleAware.org
              </a>
              . Terms and conditions apply to all offers and promotions.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

